import Dosa from "../images/istockphoto-1292563627-612x612.jpg";
import Chola from "../images/images1.jpeg";
import Idli from "../images/images.jpeg";
import MasalaDosa from "../images/Untitled2.jpeg";
import Paneer from "../images/Untitled1.jpeg";
import Gujrati from "../images/Untitled.jpeg";

export const MenuList = [
  {
    name: "Dosa",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Dosa,
    price: 200,
  },
  {
    name: "Italian Bowl",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Chola,
    price: 250,
  },
  {
    name: "Spring Roll",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Idli,
    price: 300,
  },
  {
    name: "Pasta",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: MasalaDosa,
    price: 100,
  },
  {
    name: "Manchurian",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Paneer,
    price: 400,
  },
  {
    name: "Noodles",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Placeat, ab!",
    image: Gujrati,
    price: 500,
  },
];